export default {"src":"/_next/static/media/business8.27b99b9f.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};